import styled from "@emotion/styled";

export const Box = styled.div`
  background-color: lightgrey;
  height: 100vh;
  width: 30%;
  //padding: 10px 20px;
  text-align: left;
`;

export const List = styled.ul``;
